import type { ReactNode } from 'react';
import { PageHeader } from '@components/ui/PageHeader/PageHeader';
import styles from './styles.module.css';

type IPlaceholderProps = {
  kicker: string;
  title: string;
  body: ReactNode;
};

/** A page whose name is only known at render time (a section still to be built, a site to choose), so its header is its own. */
export function Placeholder({ kicker, title, body }: IPlaceholderProps) {
  return (
    <div className={styles.wrap}>
      <PageHeader title={title} />
      <div className={styles.kicker}>{kicker}</div>
      <p className={styles.body}>{body}</p>
    </div>
  );
}
